import { render, staticRenderFns } from "./CallRecording.vue?vue&type=template&id=67db7811&"
import script from "./CallRecording.vue?vue&type=script&lang=js&"
export * from "./CallRecording.vue?vue&type=script&lang=js&"
import style0 from "./CallRecording.vue?vue&type=style&index=0&id=67db7811&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports